import { TFunction } from 'i18next';
import { z } from 'zod';
import { createPredicateSchema } from '@/entities/predicate';

export const NEW_ID = '__NEW__' as const;

const createTermSchema = (t: TFunction<readonly ['terms', 'common']>) => {
  return z.object({
    id: z
      .union([z.number(), z.literal(NEW_ID)])
      .optional()
      .nullable(),
    name: z.string().min(1, t('common:required')),
    description: z.string().min(1, t('common:required')),
    predicate: createPredicateSchema(t('common:predicateHasIssues')).optional().nullable(),
  });
};

const createTermsFormSchema = (t: TFunction<readonly ['terms', 'common']>) => {
  return z.object({
    terms: z.array(createTermSchema(t)),
  });
};

export type TermFormValues = z.infer<ReturnType<typeof createTermsFormSchema>>;

// Export factory function for use in hooks
export const createTermsFormSchemaFactory = (t: TFunction<readonly ['terms', 'common']>) => createTermsFormSchema(t);

export type SingleTermFormValues = z.infer<ReturnType<typeof createTermSchema>>;
export const createTermSchemaFactory = (t: TFunction<readonly ['terms', 'common']>) => createTermSchema(t);
